import React from "react";
import { Wrench, Clock } from "lucide-react";
import { useBranding, assetUrl } from "@/lib/branding";

export default function Maintenance({ message, until }) {
  const branding = useBranding();
  const name = branding?.brand?.name || "Platform";
  const logo = assetUrl(branding?.brand?.logo_id);
  const accent = branding?.brand?.accent_color || "#22C55E";
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0A0A0A] px-6" data-testid="maintenance-page">
      <div className="pointer-events-none absolute -top-1/4 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full opacity-20 blur-[120px]" style={{ background: accent }} />
      <div className="relative z-10 w-full max-w-md text-center">
        <div className="mb-8 flex items-center justify-center gap-2.5">
          {logo ? <img src={logo} alt={name} className="h-8 w-auto object-contain" /> : <span className="font-display text-xl font-bold text-white">{name}</span>}
        </div>
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/[0.08] bg-white/[0.04]">
          <Wrench className="h-7 w-7" style={{ color: accent }} />
        </div>
        <h1 className="mb-3 text-2xl font-semibold text-white">Maintenance in progress</h1>
        <p className="text-sm leading-relaxed text-white/60">{message || "We're performing scheduled maintenance and will be back shortly."}</p>
        {until && (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/[0.08] bg-white/[0.03] px-4 py-2 text-sm text-white/70">
            <Clock className="h-4 w-4" /> Estimated finish: <span className="text-white">{until}</span>
          </div>
        )}
        <p className="mt-8 text-xs text-white/30">Thank you for your patience.</p>
      </div>
    </div>
  );
}
